import axios from 'axios';
import Cookies from 'js-cookie';
import { API_URLS } from '../urls';

// Single axios instance for the whole app.
//
// Every call site used to build `${API_URLS.BASE_URL}path` by hand and attach
// the Authorization header itself. That duplication is what produced the
// `//user` double-slash bug, so paths passed here should be relative and
// without a leading slash -- axios joins them against baseURL.
const client = axios.create({
  baseURL: API_URLS.BASE_URL,
  maxBodyLength: Infinity,
});

client.interceptors.request.use((config) => {
  const accessToken = Cookies.get('access_token');
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export default client;
